<template>
  <div style="font-size: 20px;text-align: left;margin: 50px">
    <el-row style="text-align: left">
      <div style="font-size: 35px;font-weight: bold">办事指南</div>
    </el-row>
    <el-row>
      <hr size=1 style="COLOR:#ff9999;border-style:double;color:#CCC;margin-top: 20px"/>
    </el-row>
    <el-table
      :data="data"
      border
      v-loading="loading"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="文件名">
      </el-table-column>
      <el-table-column
        label="下载">
        <template slot-scope="scope">
          <el-button type="text"  @click="download_template(scope.row.url)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  export default {
    data(){
      return{
        data:[],
        loading:false,
        sysFunctionsIntroduce:'/draw/sysFunctionsIntroduce',
      }
    },
    mounted(){
      this.query();
    },
    methods:{
      download_template(uploadUrl){
         
        const link = document.createElement('a');
        link.href = uploadUrl;
        link.setAttribute('download', '');
        document.body.appendChild(link);
        link.click();
      },
      query(){
        this.loading = true;
        this.$http.get(
          this.sysFunctionsIntroduce+"?code=guidance"
        ).then((res) => {
          if(res.body.status === 200){
            this.data = JSON.parse(res.data.result.data[0].url);
          }else{
            this.$message.error("请求出错")
          }
          this.loading = false;
        });
      }
    }
  }
</script>
<style scoped>
  br{
   margin-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/views/login/guidance.vue